import React from 'react'
import BuildingSummary from './components/buildingSummary.tsx';
import EfficiencySummaryReport from './components/efficiencySummary.tsx';
import EnergyDistributionGraph from './components/energyDistributionGraph.tsx';
import GaugeChartComponent from './components/gaugeChart.tsx';
import EmissionsBarLineChart from './components/emissionBarLine.tsx';
import { ThreeFloorsPng } from '../../../assets/index.js';

const BuildingViewPage = () => {
  return (
    <div className='mainSection'>
      <div className='row'>
        <div className='col-lg-3 col-md-12 col-12'>
          <div className="box px-2">
            <BuildingSummary />
            <EfficiencySummaryReport />
          </div>
        </div>
        <div className='col-lg-6 col-md-12 col-12'>
          <div className='image-container c-floor p-4'>
            <div className='c-img-title'>
              {/* <div> */}
              <h4 className='img-title'>ES Industrial Park Demo / ES 01</h4>
              {/* </div> */}
            </div>
            <div className='d-flex justify-content-around c-t-floor' style={{ flexDirection: 'column' }}>
                <span>Floor 3</span>
                <span>Floor 2</span>
                <span>Floor 1</span>
              </div>
            <div className='row'>
              <div className='col-1'></div>
              <div className='col-11'>
                <img src={ThreeFloorsPng} width={"100%"} />
              </div>
            </div>
          </div>
          <EmissionsBarLineChart />
        </div>
        <div className='col-lg-3 col-md-12 col-12'>
          <EnergyDistributionGraph />
          <div className='p-2'>
            <GaugeChartComponent />
          </div>
        </div>
      </div>
      {/* <div className="col-3 py-2" id="mainSection">
        
      </div> */}
    </div>
  )
}

export default BuildingViewPage;